
/**
 * 专家路由
 */
// import Layout from '@/baseLayout/LayoutPage'
const roleSpecial = "special"
export const routesSP = {
        path: "/special",
        name:"special",
        // component:Layout,
    redirect:"/special/firstscoring",
        children:[
            {
                path: 'judgelist',
                // component: () => import(/* webpackChunkName: "about" */ '../views/special/JudgeListView.vue'),
                meta:{title:"奖学金申请列表",menuShow:true,role:roleSpecial}
            },
            {
                path: 'judgeDetail',
                // component: () => import(/* webpackChunkName: "about" */ '../views/special/JudgeDetailView.vue'),
                meta:{title:"奖学金评分",menuShow:false,role:"special"}
            }
        ]
    }

